import { VFC } from 'react';
import { Form, Modal, Row } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { Locale } from '@enmon/commons';
import { Button } from '../Button/Button';
import { useSettingsModalVisibilityStore } from './store';
import { Modal as messages } from './messages';
import { Select } from '../Select/Select';
import { useSessionStore } from '../../store/session';
import { filterSort } from '../Select/utils';

const SETTINGS_MODAL_FORM_ID = 'settings-modal-form';

export const SettingsModal: VFC = () => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { locale, setLocale } = useSessionStore();

  const { setVisibility: setSettingsModalVisibility } = useSettingsModalVisibilityStore();

  return (
    <Modal
      open
      footer={
        <Row wrap={false}>
          <Button
            block
            type="primary"
            onClick={() => {
              setLocale(form.getFieldValue('language') as Locale);
              setSettingsModalVisibility(false);
            }}
          >
            <FormattedMessage {...messages.ok} />
          </Button>
        </Row>
      }
      title={<FormattedMessage {...messages.settings} />}
      onCancel={() => setSettingsModalVisibility(false)}
    >
      <Form form={form} id={SETTINGS_MODAL_FORM_ID} initialValues={{ language: locale }}>
        <Form.Item label={intl.formatMessage(messages.selectLanguage)} name="language">
          <Select
            className="w-100"
            filterSort={filterSort}
            options={[
              { value: Locale.CS, label: intl.formatMessage(messages.czech) },
              { value: Locale.SK, label: intl.formatMessage(messages.slovak) },
              { value: Locale.EN, label: intl.formatMessage(messages.english) },
              { value: Locale.PL, label: intl.formatMessage(messages.polish) },
            ]}
            size="large"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
